export default "__VITE_ASSET__BhGCq7dZ__"